export const sendMessageToClient = (event, data) => {
  window.parent.postMessage({ event, data }, '*');
};
